<template>
  <v-card
    id="booking-account"
    class="mx-auto secondary rounded-0"
    elevation="0"
  >
    <CardHeader title="1. HVEM?" />
    <v-row no-gutters>
      <v-col
        :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
        :class="
          this.$vuetify.breakpoint.smAndDown ? 'pt-2 px-2' : 'pt-6 pb-2 px-9'
        "
      >
        <v-select
          v-model="account"
          label="Afdeling"
          :items="accounts"
          item-value="id"
          return-object
          :rules="accountRules"
          outlined
          dense
          color="primary"
          background-color="white"
          :menu-props="{ contentClass: 'combobox-styled', nudgeBottom: 30 }"
        >
          <template slot="selection" slot-scope="data">
            {{ data.item.name }}, {{ data.item.city }}, {{ data.item.id }}
          </template>
          <template slot="item" slot-scope="data">
            {{ data.item.name }}, {{ data.item.city }}, {{ data.item.id }}
          </template>
          <v-tooltip bottom slot="append-outer" color="info">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="info" style="pointer-events: auto;">
                {{ helpIcon }}
              </v-icon>
            </template>
            <span>
              {{ accountHelpText }}
            </span>
          </v-tooltip>
        </v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { dictionary } from "../helpers";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  components: {
    CardHeader
  },
  data: () => ({
    accountRules: [v => !!v || false],
    helpIcon: dictionary.mdi.help,
    accountHelpText: dictionary.help.account
  }),
  computed: {
    accounts() {
      return this.$store.state.user.activeUser
        ? this.$store.state.user.activeUser.accounts
        : [];
    },
    account: {
      get() {
        return this.$store.state.booking.data.account;
      },
      set(account) {
        this.$store.state.booking.data.account = account; //set account directly to provoke watch/listeners in other components.
        this.$store.commit("booking/updateAccount", account);
      }
    }
  }
};
</script>
